// extracted by mini-css-extract-plugin
module.exports = {"box":"styled-module--box--2atTt"};